<template>
  <div id="IndexPage" :style="{'background-image':'url('+tenantConfig.homeBg+')',
                                'background-repeat':tenantConfig.homeBgRepeat, 
                                'background-color':tenantConfig.homeBgColor}">
    <div class="banner" :style="{'width': tenantConfig.bannerWidth}">
      <a-carousel :autoplay="false" arrows>
        <template #prevArrow>
          <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
            <i class="iconfont">&#xe622;</i>
          </div>
        </template>
        <template #nextArrow>
          <div class="custom-slick-arrow" style="right: 10px">
            <i class="iconfont">&#xe624;</i>
          </div>
        </template>
        <div v-for="(banner, index) in bannerList" :key="index" alt="">
          <div v-if="banner.endsWith('mp4')" class="video-box">
            <div class="video-mask" style=""></div>
            <video class="video" autoplay="" loop="" muted="" :src="banner">
              <source :src="banner" type="video/mp4" />
            </video>
            <div class="typed">
              <vue-typed-js :strings="bannerLinksList" loop smartBackspace>
                <span class="typing"></span>
              </vue-typed-js>
            </div>
          </div>
          <img class="img" v-else :src="banner" />
        </div>
      </a-carousel>
    </div>
    <div>
        <div class="boxBackground" >
          <div class="boxContent" v-html="tenantConfig.homeHtml"></div>
        </div>
        <div v-if="teacherBannerList.length>0" class="boxBackground boxBackground8">
          <div class="boxContent">
            <p class="boxTitle">师资力量</p>
            <a-carousel :autoplay="true" arrows style="width: 80%">
              <template #prevArrow>
                <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
                  <i class="iconfont">&#xe622;</i>
                </div>
              </template>
              <template #nextArrow>
                <div class="custom-slick-arrow" style="right: 10px">
                  <i class="iconfont">&#xe624;</i>
                </div>
              </template>
              <div class="TeacherBox" v-for="item,index in teacherBannerList" :key="index">
                <img :src="item.img" class="box_image" alt="" />
                <p class="teacherName" :style="{'background':tenantConfig.homeBgColor}">{{ item.name }}</p>
              </div>
            </a-carousel>
          </div>
        </div>
      </div>
    <Footer/>
  </div>
</template>
<script>
// import { getAction } from "@/api/manage";
import Footer from "@/components/footer/Footer";

export default {
  components: { Footer },
  data() {
    return {
      bannerList:[],
      bannerLinksList: [],
      teacherBannerList:[]
    };
  },
  watch: {},
  methods: {},
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
    if (this.tenantConfig && this.tenantConfig.banner) {
      this.bannerList = this.tenantConfig.banner.split(",");
    }
    if(this.tenantConfig.bannerLinks){
      this.bannerLinksList = this.tenantConfig.bannerLinks.split("\n");
    }
    if (this.tenantConfig && this.tenantConfig.banner2) {
      this.teacherBannerList = this.tenantConfig.banner2.split(",");
      let bannerList = this.tenantConfig.banner2.split(",");
      let bannerNameList = [];
      if(this.tenantConfig.bannerLinks2){
        bannerNameList = this.tenantConfig.bannerLinks2.split("\n");
      }
      
      for (let i = 0; i < bannerList.length; i++) {
        this.teacherBannerList[i] = {
          img: bannerList[i],
          name: bannerNameList.length <= (i-1) ? bannerNameList[i] : '',
        };
      }
    }
    // let timer = setTimeout(()=>{this.AIxStatus = true ,clearTimeout(timer)},5000)
  },
  mounted() {
  },
};
</script>
<style lang='less' scoped>
.slick-arrow {
  border-radius: 50%;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 40px;
  background: #364e799a;
  overflow: hidden;
  color: #fff;
  opacity: 0.5;
  img {
    width: 100%;
    height: 100%;
  }
}
.slick-arrow:hover {
  background: #364e79;
  color: #fff;
  opacity: 1;
}
    .typed {
      position: absolute;
      top: 50%;
      width: 100%;
      /deep/.typed-element {
        justify-content: center;
        .typing {
          color: #fff;
          font-size: 2rem;
        }
        .typed-cursor {
          color: #fff;
          font-size: 2rem;
        }
      }
    }

#IndexPage {
  width: 100%;
  height: auto;
  .banner-wide {
    width: 100%;
    height: 100%;
    background: #ccc;
  }
  .banner{
    max-width: 100%;
    margin: auto;
    // max-width: 1200px;
    overflow: hidden;
    border-radius: 28px;
    box-shadow: 0 6px 10px rgba(3,3,3,.12156862745098039);

    .img{
      width: 100%;
    }
    .video{
      width: 100%;
    }
}
  .boxBackground {
    width: 100%;
   // background: #030149;
    .boxContent {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      // max-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .boxTitle {
        width: 100%;
        line-height: 60px;
        color: #fff;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        padding-bottom: 30px;
      }
      .box_image {
        width: 100%;
        height: auto;
      }
      .TeacherBox {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        position: relative;
        .teacherName {
          width: 100%;
          line-height: 50px;
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          text-align: left;
          padding: 0 20px;
          position: absolute;
          left: 0;
          bottom: 0;
          background: rgb(10 0 85);
        }
      }
      .questionList {
        width: 100%;
        text-align: left;
        line-height: 40px;
        font-weight: bold;
        font-size: 14px;
        color: #fff;
      }
    }
  }
}
.mobile{
  .boxBackground {
    .boxContent {
      width: 100%!important;
      /deep/img{
        max-width: 100%;
      }
    }
  }
}
</style>